import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@talbenmoshe/prometheus-react-app-runtime';
import { AxiosHttpClientFactoryCreator } from '@talbenmoshe/http-client';
import { SignInContextProvider, createTripOsUsersApp } from '@talbenmoshe/trip-os-react-model';
import { ThemeProvider } from '@talbenmoshe/trip-os-design-system';
import '@talbenmoshe/trip-os-design-system/styles.css';
import { routeTree } from './.autogen/routeTree.gen.js';
import { SystemClock } from './host/SystemClock.js';
import { WindowIntervalTimer } from './host/WindowIntervalTimer.js';
import { WindowPageNavigator } from './host/WindowPageNavigator.js';
import { createAppTranslator } from './i18n/createAppTranslator.js';
import { MessagesProvider } from './i18n/messagesContext.js';

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

async function bootstrap(): Promise<void> {
  const root = document.getElementById('root');

  if (!root) {
    throw new Error('Root element not found');
  }

  const { messages, localeController, localeSwitcher } = await createAppTranslator();
  const facade = createTripOsUsersApp(
    new AxiosHttpClientFactoryCreator(),
    new WindowPageNavigator(window.location),
    new SystemClock(),
    new WindowIntervalTimer(window)
  );

  ReactDOM.createRoot(root).render(
    <StrictMode>
      <ThemeProvider>
        <MessagesProvider messages={messages} localeController={localeController} localeSwitcher={localeSwitcher}>
          <SignInContextProvider facade={facade}>
            <RouterProvider router={router} />
          </SignInContextProvider>
        </MessagesProvider>
      </ThemeProvider>
    </StrictMode>
  );
}

bootstrap();
